module.exports = __webpack_public_path__ + "static/media/connexion.e601036c.png";